var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8964_36644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0V1080H1920V0Z",
    fill: "#A5211F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1786.3 861.099C1786.3 861.099 1782 858.099 1783.3 855.599C1784.6 852.999 1785.8 856.099 1788.1 854.199C1790.6 852.199 1789.8 851.099 1792.9 852.299C1794.7 852.999 1794.5 857.999 1794.5 857.999C1794.5 857.999 1794.8 854.199 1798.1 854.599C1801.3 855.099 1798.7 857.499 1800.1 857.999C1801.6 858.499 1804.7 858.899 1804 860.899C1803.3 862.899 1799.8 863.099 1799.8 863.099C1799.8 863.099 1804.3 863.299 1804.4 866.099C1804.5 868.999 1802.8 868.799 1801.8 869.999C1800.8 871.199 1802.8 872.099 1799.6 873.099C1796.4 874.099 1794.4 869.699 1794.4 869.699C1794.4 869.699 1796.9 873.999 1793.9 874.999C1790.9 875.999 1792.2 873.999 1790.6 873.799C1789 873.599 1787.7 875.599 1786 873.699C1784.3 871.799 1787.4 869.199 1787.1 869.399C1786.8 869.599 1782.6 871.399 1781.3 870.599C1779.9 869.799 1779.9 867.499 1780.2 866.199C1780.4 864.899 1779.5 863.799 1780.4 861.999C1781.4 860.299 1786.3 861.099 1786.3 861.099Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1793.5 860.399C1798.2 860.999 1797.8 867.599 1792.4 866.999C1787 866.399 1788.9 859.699 1793.5 860.399Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791.5 867.898C1791.5 867.898 1787.9 870.498 1790.1 872.098C1792.2 873.798 1791.5 867.898 1791.5 867.898Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1788.3 864.5C1788.3 864.5 1784 862.5 1783.1 864.9C1782.3 867.3 1788.3 864.5 1788.3 864.5Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791 859.597C1791 859.597 1787.4 856.497 1790 855.397C1792.5 854.397 1791 859.597 1791 859.597Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1796.5 860.797C1796.5 860.797 1796.3 856.797 1798.5 857.797C1800.8 858.797 1796.5 860.797 1796.5 860.797Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1797.1 865.999C1797.1 865.999 1803.3 865.799 1800.8 868.999C1799.1 871.499 1797.1 865.999 1797.1 865.999Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1641.4 809.099C1641.4 809.099 1637.1 806.099 1638.4 803.599C1639.7 800.999 1640.9 804.099 1643.2 802.199C1645.7 800.199 1644.9 799.099 1648 800.299C1649.8 800.999 1649.6 805.999 1649.6 805.999C1649.6 805.999 1649.9 802.199 1653.2 802.599C1656.4 803.099 1653.8 805.499 1655.2 805.999C1656.7 806.499 1659.8 806.899 1659.1 808.899C1658.4 810.899 1654.9 811.099 1654.9 811.099C1654.9 811.099 1659.4 811.299 1659.5 814.099C1659.6 816.999 1657.9 816.799 1656.9 817.999C1655.9 819.199 1657.9 820.099 1654.7 821.099C1651.6 822.099 1649.5 817.699 1649.5 817.699C1649.5 817.699 1652 821.999 1649 822.999C1646 823.999 1647.3 821.999 1645.7 821.799C1644.1 821.599 1642.8 823.599 1641.1 821.699C1639.3 819.899 1642.5 817.199 1642.2 817.399C1641.9 817.499 1637.7 819.399 1636.4 818.599C1635 817.799 1635 815.499 1635.3 814.199C1635.6 812.899 1634.6 811.799 1635.5 809.999C1636.4 808.199 1641.4 809.099 1641.4 809.099Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1648.6 808.398C1653.3 808.998 1652.9 815.598 1647.5 814.998C1642.1 814.398 1643.9 807.798 1648.6 808.398Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.6 815.898C1646.6 815.898 1643 818.498 1645.2 820.098C1647.3 821.798 1646.6 815.898 1646.6 815.898Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1643.4 812.598C1643.4 812.598 1639.1 810.598 1638.2 812.998C1637.4 815.298 1643.4 812.598 1643.4 812.598Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1646.1 807.597C1646.1 807.597 1642.5 804.497 1645.1 803.397C1647.6 802.397 1646.1 807.597 1646.1 807.597Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651.6 808.899C1651.6 808.899 1651.4 804.899 1653.6 805.899C1655.8 806.799 1651.6 808.899 1651.6 808.899Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652.2 813.999C1652.2 813.999 1658.4 813.799 1655.9 816.999C1654.2 819.499 1652.2 813.999 1652.2 813.999Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1737.7 930.8C1737.7 930.8 1740 899.9 1767.1 893.7C1802.9 885.5 1806.1 927.5 1804.5 925.6C1788.9 907.7 1777.7 912.2 1771.8 914.1C1771.8 914.1 1781.4 912.7 1787.9 917.5C1794.4 922.3 1791.4 947.5 1789.8 944.9C1788.2 942.3 1781.3 922.5 1773.7 924.3C1773.7 924.3 1779 928.4 1779.9 932.6C1780.7 936.8 1777.8 949.6 1776.1 947.1C1774.3 944.6 1768.5 933.8 1768.5 933.8C1768.5 933.8 1770.3 949.5 1767.2 950.1C1764.1 950.7 1760.1 940.3 1760.1 940.3C1760.1 940.3 1755.9 951.5 1752.7 951.7C1749.5 951.9 1746.9 946 1746.9 946C1746.9 946 1746.9 952.2 1744.8 950.9C1742.5 949.6 1737.7 930.8 1737.7 930.8Z",
    fill: "#FFF7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738.7 936C1738.7 936 1744 940.3 1746.1 939.5C1748.2 938.7 1745.1 934.5 1745.1 934.5C1745.1 934.5 1750.2 937.5 1751.8 935.6C1753.4 933.7 1748 931.8 1748 931.8C1748 931.8 1757.3 934.4 1756.5 931.6C1755.7 928.9 1747.1 928.7 1747.1 928.7C1747.1 928.7 1763.8 927.3 1760.2 923.6C1756.5 919.9 1740.3 923.4 1740.3 923.4L1738.7 936Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1755.41 901.398C1755.41 901.398 1763.21 893.698 1776.11 895.198",
    stroke: "#4E003D",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.1 895.801C1781.1 895.801 1785.3 895.601 1788.3 897.901",
    stroke: "#4E003D",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1774.1 898.801C1774.1 898.801 1777.3 897.801 1780.7 899.101",
    stroke: "#4E003D",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1790.41 900.801C1790.41 900.801 1791.51 900.801 1794.11 903.501",
    stroke: "#4E003D",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1785.6 901.199C1785.6 901.199 1789.3 902.799 1790.6 903.799",
    stroke: "#4E003D",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1796.6 907.199C1796.6 907.199 1797.9 908.799 1799.3 910.899",
    stroke: "#4E003D",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1770.3 916.498C1770.3 916.498 1777.7 914.398 1782.9 918.298",
    stroke: "#4E003D",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1787 920.5C1787 920.5 1788.8 921.3 1789.6 925.8",
    stroke: "#4E003D",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780.5 920.801C1780.5 920.801 1783.5 921.001 1785.8 923.701",
    stroke: "#4E003D",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.1 929.5C1789.1 929.5 1789.9 931.6 1789.9 933.7",
    stroke: "#4E003D",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1768.41 924.5C1768.41 924.5 1772.71 925.1 1774.61 928",
    stroke: "#4E003D",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1777.41 932C1777.41 932 1778.01 933.1 1778.01 935.7",
    stroke: "#4E003D",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1772 929.598C1772 929.598 1773.9 930.398 1774.7 932.598",
    stroke: "#4E003D",
    strokeWidth: 0.992,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1688.1 938.5L1680.7 947.1C1680.7 947.1 1677.7 939.9 1677.3 941C1676.8 942 1678 945.2 1678 945.2C1678 945.2 1673.9 940.2 1674.1 941.7C1674.3 943.1 1676.3 947 1676.3 947C1676.3 947 1671.3 945 1672.2 946.5C1673.1 948 1679.2 950.6 1679.2 950.6C1679.2 950.6 1682.4 956.4 1683.1 955.7C1683.8 955 1683 949.9 1683 949.9L1692 944.5L1688.1 938.5Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.8 942.102C1684.8 942.102 1688 945.502 1688.4 946.602",
    stroke: "#4E003D",
    strokeWidth: 0.744,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1683.4 943.801C1683.4 943.801 1685.8 947.001 1686 948.101",
    stroke: "#4E003D",
    strokeWidth: 0.744,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1681.7 946C1681.7 946 1683.5 948.6 1683.8 949.5",
    stroke: "#4E003D",
    strokeWidth: 0.744,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687.81 923.801C1688.11 919.401 1667.71 904.301 1660.61 908.801C1653.51 913.301 1664.51 918.201 1664.51 918.201C1664.51 918.201 1659.11 917.201 1659.31 919.001C1659.51 920.801 1663.61 921.301 1663.61 921.301C1663.61 921.301 1658.21 921.601 1659.31 923.501C1660.41 925.401 1666.71 925.501 1666.71 925.501C1666.71 925.501 1660.71 925.501 1663.21 928.601C1671.01 938.601 1687.01 934.901 1687.81 923.801Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1680.11 917.6C1680.11 917.6 1673.61 912.2 1670.21 913.8C1666.81 915.4 1671.61 922 1671.61 922C1671.61 922 1667.71 917.8 1667.41 920.6C1667.11 923.4 1673.21 926.8 1673.21 926.8C1673.21 926.8 1666.41 926 1668.61 928.6C1670.81 931.1 1682.31 935.3 1684.81 930.8C1687.61 926.1 1680.11 917.6 1680.11 917.6Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730.4 903.896C1730.4 903.896 1754 913.696 1741.2 937.296C1723.4 970.096 1646.3 947.296 1696.6 892.996L1730.4 903.896Z",
    fill: "#FFF7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1681 915.695C1681 915.695 1674.6 926.095 1676.8 927.095C1679 928.095 1682.4 923.395 1682.4 923.395C1682.4 923.395 1679.3 929.395 1685.1 930.895C1690.9 932.395 1693.8 927.195 1693.8 927.195C1693.8 927.195 1694.8 934.295 1699.8 934.595C1704.8 934.795 1705.8 925.295 1705.8 925.295C1705.8 925.295 1714.1 933.395 1716.4 932.395C1718.7 931.395 1718.7 926.795 1718.7 926.795C1718.7 926.795 1726.2 932.395 1728.5 928.995C1730.8 925.595 1727.9 921.495 1727.9 921.495C1727.9 921.495 1736.2 926.095 1736.9 922.095C1737.7 917.995 1732.4 905.695 1732.4 905.695L1681 915.695Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1689.2 933.695C1689.2 933.695 1689.4 941.795 1693.4 941.695C1697.4 941.495 1695.5 933.695 1695.5 933.695",
    stroke: "#FFAC49",
    strokeWidth: 1.24,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1699 936.798C1699 936.798 1697.9 941.198 1701.6 941.398C1705.3 941.598 1703.8 936.598 1703.8 936.598",
    stroke: "#FFAC49",
    strokeWidth: 1.24,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.8 936.096C1707.8 936.096 1708.4 942.396 1711 941.296C1713.6 940.196 1711.4 934.996 1711.4 934.996",
    stroke: "#FFAC49",
    strokeWidth: 1.24,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1715.8 935.596C1715.8 935.596 1716.4 940.796 1719 940.196C1721.6 939.596 1719.6 933.996 1719.6 933.996",
    stroke: "#FFAC49",
    strokeWidth: 1.24,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1723.6 933.698C1723.6 933.698 1724.8 939.798 1727 937.698C1729.2 935.598 1727.7 932.598 1727.7 932.598",
    stroke: "#FFAC49",
    strokeWidth: 1.24,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1736.21 915.198C1736.91 910.798 1760.11 900.698 1766.01 906.698C1771.91 912.698 1760.11 914.898 1760.11 914.898C1760.11 914.898 1765.51 915.098 1765.01 916.798C1764.41 918.498 1760.31 918.098 1760.31 918.098C1760.31 918.098 1765.51 919.598 1764.11 921.198C1762.61 922.798 1756.41 921.498 1756.41 921.498C1756.41 921.498 1762.21 922.898 1759.11 925.298C1749.11 933.298 1734.41 926.098 1736.21 915.198Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1752.41 908.498C1755.01 911.298 1747.81 914.998 1747.81 914.998C1747.81 914.998 1755.41 913.898 1755.61 917.398C1755.81 920.998 1748.51 920.698 1748.51 920.698C1748.51 920.698 1756.11 923.698 1752.31 926.398C1748.41 929.198 1740.51 924.198 1738.31 918.598C1736.21 913.098 1749.81 905.798 1752.41 908.498Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1712.61 946.598L1705.21 955.198C1705.21 955.198 1702.21 947.998 1701.81 949.098C1701.31 950.098 1701.81 954.098 1701.81 954.098C1701.81 954.098 1698.41 948.298 1698.51 949.698C1698.71 951.098 1700.81 956.498 1700.81 956.498C1700.81 956.498 1695.71 952.998 1696.61 954.598C1697.61 956.098 1704.21 959.998 1704.21 959.998C1704.21 959.998 1706.81 964.498 1707.51 963.798C1708.21 963.098 1707.41 957.998 1707.41 957.998L1720.01 950.498L1712.61 946.598Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1711.2 947.996C1711.2 947.996 1716.3 950.596 1716.8 952.196",
    stroke: "#4E003D",
    strokeWidth: 0.744,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1709.2 950.199C1709.2 950.199 1713.2 952.599 1713.9 954.099",
    stroke: "#4E003D",
    strokeWidth: 0.744,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1707.11 952.797C1707.11 952.797 1709.61 954.297 1710.51 955.997",
    stroke: "#4E003D",
    strokeWidth: 0.744,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1752 894.198C1752.9 892.198 1763.5 865.198 1748.6 845.698C1740.6 835.198 1729.2 831.398 1720 829.498C1699.4 825.298 1685.4 827.198 1676.4 832.698C1670.1 835.998 1665.7 840.798 1662.7 847.198C1660 852.198 1658.5 860.198 1658.5 860.198C1626.4 883.998 1661.5 916.398 1685 919.698C1692.8 920.698 1699.2 920.998 1704 920.898C1716.6 920.898 1726.5 920.698 1735.8 914.898C1739.6 912.498 1742.2 909.898 1743.2 908.798C1748.5 903.298 1750.9 897.598 1752 894.198Z",
    fill: "#FFF7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1687.1 835.596C1687.1 835.596 1690.5 831.596 1694.9 833.496C1698.8 835.196 1699.1 838.096 1699.1 838.096",
    stroke: "#4E003D",
    strokeWidth: 1.24,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1703.7 827.297C1703.7 827.297 1725.9 827.497 1740 837.397",
    stroke: "#4E003D",
    strokeWidth: 0.992,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720.51 920.898C1761.91 912.098 1756.21 865.598 1756.21 865.598",
    stroke: "#4E003D",
    strokeWidth: 1.24,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.5 860.398C1659.5 860.398 1642 868.098 1646.8 888.198C1652 910.098 1680.3 918.698 1680.3 918.698",
    stroke: "#4E003D",
    strokeWidth: 1.24,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1688.01 842.5C1705.31 843.3 1701.21 879.2 1683.81 877.8C1667.01 876.4 1674.31 841.9 1688.01 842.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.71 850.4C1703.11 853.8 1697.51 876.7 1688.41 875.5C1677.81 874.1 1683.91 846.9 1693.71 850.4Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1721.3 848.397C1726.7 848.597 1730 852.297 1731.6 857.097C1735 868.097 1729.3 885.297 1717 884.197C1699.1 882.797 1706.6 847.697 1721.3 848.397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1726 854.796C1735.6 858.296 1729.8 881.796 1720.6 880.596C1709.8 879.196 1716.1 851.196 1726 854.796Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1710.4 888.196C1710.4 888.196 1726.5 865.396 1742.9 881.896L1710.4 888.196Z",
    fill: "#FFF7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730.4 879.596C1740 884.696 1731.8 899.296 1721.8 893.796C1711.8 888.396 1719.5 873.796 1730.4 879.596Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1708.5 889.996C1708.5 889.996 1727.4 863.796 1742.9 881.796",
    stroke: "#4E003D",
    strokeWidth: 1.24,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1666.6 866.898C1667.1 866.998 1684.8 869.098 1684.1 887.098L1666.6 866.898Z",
    fill: "#FFF7EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1666.6 866.898C1667.1 866.998 1684.8 869.098 1684.1 887.098",
    stroke: "#4E003D",
    strokeWidth: 1.24,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1676.8 873.499C1685.3 881.399 1673.5 893.399 1664.7 885.099C1656 876.799 1667.3 864.499 1676.8 873.499Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1691.4 873.598C1691.4 873.598 1668 885.298 1682 897.198C1691.9 905.798 1696.6 890.998 1696.6 890.998C1696.6 890.998 1698.5 904.998 1708.8 899.698C1723.7 892.198 1704 874.798 1704 874.798L1691.4 873.598Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1692.2 863.799C1689.9 863.899 1689.3 872.399 1693.1 876.299C1691.3 879.899 1688.5 885.899 1691.1 886.499C1694.8 887.299 1706.1 882.699 1706.7 877.299C1707 873.999 1703.1 863.499 1692.2 863.799Z",
    fill: "#FFAD48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693 866.799C1693 866.799 1702 873.399 1701.7 876.499C1701.4 879.499 1694.1 886.499 1692.7 885.199C1692.2 884.699 1695.1 878.699 1694.1 875.799C1692.4 870.199 1691.2 865.699 1693 866.799Z",
    fill: "#4E003D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1716.7 843.596C1716.7 843.596 1720.1 839.596 1724.5 841.496C1728.4 843.196 1728.7 846.096 1728.7 846.096",
    stroke: "#4E003D",
    strokeWidth: 1.24,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1746.61 856.899C1746.61 856.899 1746.41 861.499 1748.41 861.799C1750.31 861.999 1749.81 856.199 1749.81 856.199",
    stroke: "#4E003D",
    strokeWidth: 1.24,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750.4 864.798C1750.4 864.798 1749.1 867.798 1751.3 868.798C1753.5 869.698 1753 863.398 1753 863.398",
    stroke: "#4E003D",
    strokeWidth: 1.24,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1750.1 873.799C1750.1 873.799 1749.6 878.499 1751.6 879.099C1753.7 879.599 1753.9 872.699 1753.9 872.699",
    stroke: "#4E003D",
    strokeWidth: 1.24,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1748.2 885.196C1748.2 885.196 1746.9 888.396 1748.6 888.896C1750.3 889.396 1751.6 883.996 1751.6 883.996",
    stroke: "#4E003D",
    strokeWidth: 1.24,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1747 893.696C1747 893.696 1745.2 897.096 1746.6 897.796C1748 898.496 1750 893.496 1750 893.496",
    stroke: "#4E003D",
    strokeWidth: 1.24,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1696.41 827.998C1694.11 815.498 1706.91 799.398 1709.51 801.698C1712.11 803.998 1711.21 808.398 1713.21 807.998C1715.21 807.598 1717.81 800.198 1721.21 800.998C1724.61 801.698 1721.31 805.698 1724.51 805.798C1727.61 805.898 1733.41 797.998 1736.41 802.798C1739.41 807.798 1733.41 816.098 1737.21 816.398C1741.01 816.698 1755.91 805.798 1758.31 814.798C1760.71 823.798 1760.51 846.798 1740.91 840.398C1718.81 833.198 1698.21 837.798 1696.41 827.998Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1756.91 814.797C1756.91 814.797 1757.71 817.997 1757.51 821.797",
    stroke: "#C01B19",
    strokeWidth: 1.24,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1755.71 821.598C1755.71 821.598 1756.11 822.898 1755.51 826.198",
    stroke: "#C01B19",
    strokeWidth: 1.24,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1757.41 827.496C1757.41 827.496 1757.61 829.696 1756.11 833.296",
    stroke: "#C01B19",
    strokeWidth: 1.24,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1753.81 830.297C1753.81 830.297 1753.31 833.697 1751.91 836.497",
    stroke: "#C01B19",
    strokeWidth: 1.24,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1753.11 813.699C1753.11 813.699 1754.01 815.099 1754.11 818.099",
    stroke: "#C01B19",
    strokeWidth: 1.24,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1697.81 850.196C1697.51 849.296 1696.31 845.696 1692.61 843.796C1691.81 843.396 1689.61 842.196 1686.61 842.596C1684.11 842.896 1682.41 844.296 1681.31 845.196C1679.11 846.996 1678.11 848.996 1677.01 851.196C1674.81 855.596 1674.31 859.496 1674.11 861.496C1673.91 863.296 1673.91 866.096 1674.61 869.296",
    stroke: "#4E003D",
    strokeWidth: 1.24,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1730.7 855.196C1730.3 854.296 1729 851.396 1725.7 849.696C1723.4 848.496 1721.2 848.496 1720.7 848.496C1717.8 848.596 1715.8 849.896 1714.9 850.496C1713.4 851.496 1712.6 852.696 1711.7 853.596C1711.5 853.896 1710.4 855.296 1709.3 857.496C1708.6 858.896 1707.2 861.996 1706.7 866.096C1706.5 867.396 1706.2 869.496 1706.5 872.196C1706.6 873.396 1706.7 875.096 1707.5 876.996C1707.9 877.996 1708.4 879.196 1709.4 880.496C1710.7 882.096 1712.2 882.996 1713.4 883.496",
    stroke: "#4E003D",
    strokeWidth: 1.24,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.605 929.699C127.605 929.699 129.805 956.499 124.805 962.999",
    stroke: "#FFAC49",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.005 932.398C131.005 932.398 133.005 956.198 130.805 962.298",
    stroke: "#FFAC49",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.508 933.699C143.508 933.699 144.708 956.299 147.008 962.299",
    stroke: "#FFAC49",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.305 933.598L142.005 963.898",
    stroke: "#FFAC49",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.805 935.098C134.805 935.098 136.605 957.798 136.005 962.898",
    stroke: "#FFAC49",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.102 936.5L139.002 962.6",
    stroke: "#FFAC49",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.406 936C146.406 936 147.606 954.1 149.506 959.1",
    stroke: "#FFAC49",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.602 873.6L126.702 863L148.502 863.2L149.002 875.5L126.602 873.6Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.602 925.202L123.102 936.202L151.502 936.702L149.002 922.102L123.602 925.202Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.203 884.602C115.203 884.602 116.303 871.602 128.203 869.102C140.103 866.602 157.603 867.402 159.003 880.202C159.703 887.202 159.603 917.202 159.603 917.202C159.603 917.202 161.303 932.302 143.203 933.602C125.103 934.802 114.203 930.802 115.803 917.002L115.203 884.602Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.601 867.5C129.601 867.5 123.801 869.3 123.301 880.4C122.701 891.5 123.901 927.8 123.901 929.1C123.901 930.5 124.501 933.2 126.401 934.5",
    stroke: "#FF802C",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.602 867.5C145.602 867.5 151.402 869.2 151.902 880.3C152.502 891.3 151.302 927.2 151.302 928.5C151.302 929.8 150.702 932.6 148.802 933.9",
    stroke: "#FF802C",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.602 867.5V934.7",
    stroke: "#FF802C",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.402 897.301C213.402 897.301 215.602 924.101 210.602 930.601",
    stroke: "#FFAC49",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.7 900.102C216.7 900.102 218.7 923.902 216.5 930.002",
    stroke: "#FFAC49",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.203 901.402C229.203 901.402 230.403 924.002 232.703 930.002",
    stroke: "#FFAC49",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 901.199L227.6 931.599",
    stroke: "#FFAC49",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.5 902.699C220.5 902.699 222.3 925.399 221.7 930.499",
    stroke: "#FFAC49",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.898 904.199L224.698 930.199",
    stroke: "#FFAC49",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.203 903.602C232.203 903.602 233.403 921.702 235.303 926.702",
    stroke: "#FFAC49",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.305 841.299L212.405 830.699L234.205 830.899L234.805 843.199L212.305 841.299Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.305 892.899L208.805 903.799L237.205 904.399L234.805 889.699L209.305 892.899Z",
    fill: "#FF802C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.805 852.301C200.805 852.301 201.905 839.301 213.805 836.801C225.705 834.301 243.205 835.101 244.605 847.901C245.305 854.901 245.205 884.901 245.205 884.901C245.205 884.901 246.905 900.001 228.805 901.301C210.705 902.501 199.805 898.501 201.405 884.701L200.805 852.301Z",
    fill: "#FF1B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.304 835.098C215.304 835.098 209.504 836.898 209.004 847.998C208.404 859.098 209.604 895.398 209.604 896.698C209.604 898.098 210.204 900.798 212.104 902.098",
    stroke: "#FF802C",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.305 835.098C231.305 835.098 237.105 836.798 237.605 847.898C238.205 858.898 237.005 894.798 237.005 896.098C237.005 897.498 236.405 900.198 234.505 901.498",
    stroke: "#FF802C",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.305 835.098V902.398",
    stroke: "#FF802C",
    strokeWidth: 1.6,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8964_36644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage24);
export default __webpack_public_path__ + "static/media/image24.d7c7b87ee3154d727e4be5ecea8bf3b3.svg";
export { ForwardRef as ReactComponent };